module.exports = __webpack_public_path__ + "img/scratch-secondary-image.3f201040.png";